var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 4.51613 15.4839 0 10 0C4.47581 0 0 4.51613 0 10C0 15.5242 4.47581 20 10 20C15.4839 20 20 15.5242 20 10ZM10 12.0161C11.0081 12.0161 11.8548 12.8629 11.8548 13.871C11.8548 14.9194 11.0081 15.7258 10 15.7258C8.95161 15.7258 8.14516 14.9194 8.14516 13.871C8.14516 12.8629 8.95161 12.0161 10 12.0161ZM8.22581 5.3629C8.18548 5.08065 8.42742 4.83871 8.70968 4.83871H11.25C11.5323 4.83871 11.7742 5.08065 11.7339 5.3629L11.4516 10.8468C11.4113 11.129 11.2097 11.2903 10.9677 11.2903H8.99194C8.75 11.2903 8.54839 11.129 8.50807 10.8468L8.22581 5.3629Z",
    fill: "#FAB400"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.7d171342a2340a05f3dd9338cbc0b410.svg";
export { ForwardRef as ReactComponent };